import React from 'react';
import type { BookingStep } from '../hooks/useBookingWizard';

interface BookingProgressProps {
  currentStep: BookingStep;
}

export function BookingProgress({ currentStep }: BookingProgressProps) {
  if (currentStep >= 5) return null;

  return (
    <div className="mb-10">
      <div className="flex items-center justify-between max-w-md mx-auto">
        {[1, 2, 3, 4].map((s) => (
          <React.Fragment key={s}>
            <div
              className={`flex items-center justify-center w-11 h-11 rounded-full font-semibold transition-all ${
                s <= currentStep
                  ? 'bg-[#000000] text-white shadow-sm'
                  : 'bg-[#e2e8f0] text-[#64748b]'
              }`}
            >
              {s}
            </div>
            {s < 4 && (
              <div
                className={`flex-1 h-1 mx-3 rounded-full transition-all ${
                  s < currentStep ? 'bg-[#000000]' : 'bg-[#e2e8f0]'
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
